<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5">
      <div class="container wishlist">
        <h1 class="mb-4 text-black">{{ $t("wishlist") }}</h1>
        <p class="border-bottom border-black border-2 fs-5 mb-5 pb-4">{{ $t("an_overview_of_your_wish_list") }}</p>
        <div class="product-grid">
          <div class="grid-row row row-cols-2 row-cols-lg-3 row-cols-xl-4">
            <div
              class="col"
              v-for="wishitem of lists"
              :key="wishitem.id"
            >
              <div class="single-product swiper-slide">
                <b-link :to="`/${wishitem.product.url_key}`"><img class="product-img img-fluid border border-secondary" :src="wishitem.product.image.url" alt="" width="200" height="167"></b-link>
                <h4 class="single-product-name h5"><b-link :to="`/${wishitem.product.url_key}`">{{ wishitem.product.name }}</b-link></h4>
                <div class="single-product-meta">
                  <span
                    class="d-block in-stock text-success mb-3"
                    :class="
                      wishitem.product.stock_status === 'IN_STOCK'
                        ? 'text-success'
                        : 'text-danger'
                    "
                  >
                    {{
                      $t(
                        wishitem.product.stock_status === "IN_STOCK"
                          ? "in_stock"
                          : "out_of_stock"
                      )
                    }}
                  </span>
                  <div class="row row-cols-3 justify-content-between align-items-end">
                    <div class="price">
                      <span class="d-block selling-price">
                        {{
                          formatCurrency(
                            wishitem.product.price_range.minimum_price.final_price
                              .value
                          )
                        }}
                      </span>
                    </div>
                    <div class="d-inline-flex">
                      <a
                        class="add-to-cart btn btn-secondary btn-xl"
                        v-if="wishitem.product.stock_status === 'IN_STOCK'"
                        @click="addToCart(wishitem)"
                      >
                        <ClientOnly><i class="fa-solid fa-basket-shopping"></i></ClientOnly>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="single-product-tag-left">
                  <a @click="removeItem(wishitem.id)" class="wishlist-remove btn btn-primary btn-lg" style="color: unset !important;"><ClientOnly><i class="fa-solid fa-xmark fa-2xl"></i></ClientOnly></a>
                </div>
                <div class="single-product-tag-right">
                  <span class="badge text-bg-secondary">{{ $t("new") }}</span>
                  <span class="badge text-bg-primary">{{ $t("sale") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center my-5">
            <button @click="getAllWishlistProductAndAddToCart" class="btn btn-primary btn-big wishlist-btn">{{ $t("goto_checkout") }}</button>
            <b-pagination
              v-model="paginationConf.currentPageNr"
              :total-rows="rows"
              :per-page="paginationConf.perPage"
              @change="tmp"
              class="cst-pagination d-lg-none ms-4 mt-3"
              aria-controls="cat-item"
              align="right"
              :hide-goto-end-buttons="true"
            >
              <template #page="{ page }">
                <b-link class="page-link">
                  {{ page }}
                </b-link>
              </template>
            </b-pagination>
          </div>
        </div>
        <div class="wishlist-add my-5 pt-5" v-if="crossSellProducts.length">
          <h2 class="section-heading"><span>{{ $t("add_to_your_list") }}</span></h2>  
          <div class="product-grid">
            <ClientOnly>
              <div class="swiper">
                <div class="grid-row row row-cols-2 row-cols-lg-3 row-cols-xl-4 swiper-wrapper">
                  <div class="col swiper-slide" v-for="(product,index) of crossSellProducts" :key="`prod`+index">
                    <ProductCard :product="product" v-if="product!=null"/>
                  </div>
                </div>
              </div>
            </ClientOnly>
            <div class="swiper-button-prev swiper-nav-round wishlist-add-swiper-button-prev"></div>
            <div class="swiper-button-next swiper-nav-round wishlist-add-swiper-button-next"></div>
            <div class="d-flex justify-content-between align-items-center my-5 d-lg-none">
              <p class="fs-6 mb-0">{{ $t("articles") }} {{ paginationConf2.currentPageNr }} {{ $t("to") }} {{ Math.ceil(rows2 / paginationConf2.perPage) }} {{ $t("by") }} {{ rows2 }} in {{ $t("total") }}</p>
              <b-pagination
                v-model="paginationConf2.currentPageNr"
                :total-rows="rows2"
                :per-page="paginationConf2.perPage"
                @change="tmp2"
                class="cst-pagination ms-4 mt-3"
                aria-controls="cat-item"
                align="right"
                :hide-goto-end-buttons="true"
              >
                <template #page="{ page }">
                  <b-link class="page-link">
                    {{ page }}
                  </b-link>
                </template>
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@config";
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl";
import Cart from "@storefront/core/modules/cart/mixins";
import { mapGetters } from "vuex";
import { isMobile } from "mobile-device-detect";
import { getProductCrossSell } from "@storefront/core/data-resolver/products";
import ProductCard from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCard.vue";
import ClientOnly from "vue-client-only";

export default {
  name: "Wishlist",
  mixins: [Cart],
  metaInfo() {
    return {
      meta: [
        {
          name: "title",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_title
            : "",
        },
        {
          name: "keywords",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_keywords
            : "",
        },
        {
          name: "description",
          content: this.cmsDefaultPageContent
            ? this.cmsDefaultPageContent.meta_description
            : "",
        },
      ],
      //test 3
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Wishlist",
      // all titles will be injected into this template
      link: [{ rel: "canonical", href: config.app_url + this.$route.fullPath }],
    };
  },
  watch: {
    wishlistItems: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchCrossSellProducts();
        }
      },
      deep: true, // Use this if wishlistItems is an array or object
    },
    'paginationConf2.currentPageNr': function () {
      this.fetchCrossSellProducts();
    },
    'isMobileScreen': function () {
      this.fetchCrossSellProducts();
    },
  },
  methods: {
    imgUrl(filename) {
      return getImageUrl(filename);
    },
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    tmp(id) {
      this.showOrders = false;
      setTimeout(() => {
        this.showOrders = true;
        this.paginationConf.currentPageNr = id;
      }, 0.001);
    },
    tmp2(id) {
      this.showOrders2 = false;
      setTimeout(() => {
        this.showOrders2 = true;
        this.paginationConf2.currentPageNr = id;
      }, 0.001);
    },
    // openWishRemark(wishId) {
    //   this.$root.$emit('bv::toggle::collapse', 'remark' + wishId);
    // },
    // closeWishRemark(wishId) {},
    showWishRemark(wishId) {
      if (!this.openedRemarks[wishId]) {
        this.$set(this.openedRemarks, wishId, true);
      }
    },
    closeWishRemark(wishId) {
      if (this.openedRemarks[wishId]) {
        this.$set(this.openedRemarks, wishId, false);
      }
    },
    async addToCart(wishitem) {
      if (
        wishitem.product &&
        wishitem.product.__typename == "SimpleProduct" &&
        !wishitem.product.backorders_allowed
      ) {
        if (typeof wishitem.product.stock_qty != "undefined") {
          let quantity = wishitem.qty;
          const existingProduct = this.cartItems.find(
            (item) => wishitem.product.sku == item.product.sku
          );
          if (existingProduct) {
            quantity += existingProduct.quantity;
          }
          if (quantity > wishitem.product.stock_qty) {
            const msg = {
              type: "danger",
              title: this.$t("shopping_basket"),
              text: this.$t("product_not_in_stock_msg", {
                numberOf: wishitem.product.stock_qty,
              }),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
            return;
          }
        }
      }

      if (wishitem.product.__typename === "SimpleProduct") {
        const item =
          '{data: {sku: "' +
          wishitem.product.sku +
          '", quantity:' +
          wishitem.qty +
          "}}  ";
        let retval = await this.$store.dispatch("cart/addToCart", {
          type: wishitem.product.__typename,
          item: item,
        });
        if (retval == false) {
          const msg = {
            type: "danger",
            title: this.$t("shopping_basket"),
            text: this.$t("not_add_product"),
          };
          this.$store.dispatch("messages/sendMessage", { message: msg });
        } else {
          const msg = {
            type: "success",
            title: this.$t("shopping_basket"),
            text: this.$t("added_product"),
          };
          this.$store.dispatch("messages/sendMessage", { message: msg });
        }
      } else {
        this.$router.push(`/${wishitem.product.url_key}`);
      }
    },
    getProductConf(productSku) {
      const product = this.cartItems.find(
        (el) => el.product.sku === productSku
      );
      if (!product) return [];
      return product.configurable_options;
    },
    removeItem(id) {
      this.$store.dispatch("user/removeProductWishlist", {
        id: id,
      });
    },
    emptyWishlist() {
      this.wishlistItems.forEach((el) => this.removeItem(el.id));
    },
    async addCoupon() {
      if (this.couponCode != "") {
        const retval = await this.$store.dispatch("cart/addCouponCode", {
          code: this.couponCode,
        });
        if (retval == true) {
          const msg = {
            type: "success",
            title: this.$t("coupon_code"),
            text: this.$t("coupon_code_ok", { code: this.couponCode }),
          };
          this.$store.dispatch("messages/sendMessage", { message: msg });
          this.couponCode = "";
        }
      }
    },
    addRemark(wishitemId) {
      const description = this.remarks[wishitemId];

      // if (description !== "" && typeof description !== "undefined") {
      this.updateWishItemDesc(wishitemId, description);
      // }
    },
    async removeRemark(wishItemId) {
      this.$set(this.remarks, wishItemId, "");
      const retval = await this.$store.dispatch(
        "account/addWishItemDescription",
        { wishItemId, description: "" }
      );
      if (retval === true) {
        this.$store.dispatch("user/loadUser");
        const msg = {
          type: "success",
          title: "",
          text: this.$t("remark_not_added"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      }
    },
    async updateWishItemDesc(wishItemId, description) {
      const retval = await this.$store.dispatch(
        "account/addWishItemDescription",
        { wishItemId, description }
      );
      if (retval === true) {
        await this.$store.dispatch("user/loadUser");

        this.openedRemarks[wishItemId] = false;

        this.closeWishRemark(wishItemId);

        // this.$root.$emit("bv::toggle::collapse", "remark" + wishItemId);

        const msg = {
          type: "success",
          title: "",
          text: this.$t("remark_added"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      } else {
        const msg = {
          type: "danger",
          title: "",
          text: this.$t("remark_not_added"),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      }
    },
    async shareWishlist() {
      let { emails, message } = this.shareWishInfo;

      let customer_name = "";

      const user = this.$store.getters["user/getCurrentUser"];

      if (user) {
        customer_name = user.firstname + " " + user.lastname;
      }

      let isOk = true;

      if (emails.length === 0) {
        isOk = false;
        this.shareWishInfo.emailsState = false;
        this.shareWishInfo.emailsError = this.$t("required_field");
      }

      if (message == "") {
        isOk = false;
        this.shareWishInfo.messageState = false;
        this.shareWishInfo.messageError = this.$t("required_field");
      }

      if (isOk) {
        const retval = await this.$store.dispatch("account/shareWishlist", {
          name: customer_name,
          emails,
          message,
        });
        if (retval != false) {
          if (retval.errors.length > 0) {
            retval.errors.forEach((element) => {
              const msg = {
                type: "danger",
                title: "",
                text: element.message,
              };
              this.$store.dispatch("messages/sendMessage", { message: msg });
            });
          } else {
            const msg = {
              type: "success",
              title: "",
              text: this.$t("wish_success"),
            };
            this.$store.dispatch("messages/sendMessage", { message: msg });
          }
          this.$bvModal.hide("share-wish-modal");
        }
      }
    },
    isInCart(wishItem) {
      return this.cartItems.find(
        (item) => item.product.sku === wishItem.product.sku
      );
    },
    closeNotifyModal() {
      this.notifyModalProduct = null;
      this.showNotifyModal = false;
    },
    addToNotify(wishItem) {
      this.notifyModalProduct = wishItem.product;
      this.showNotifyModal = true;
    },
    quantityUp(wishitem) {
      if (wishitem.qty < wishitem.product.stock_qty) {
        wishitem.qty++;
      } else {
        const msg = {
          type: "danger",
          title: this.$t("shopping_basket"),
          text: this.$t("product_not_in_stock_msg", {
            numberOf: wishitem.product.stock_qty,
          }),
        };
        this.$store.dispatch("messages/sendMessage", { message: msg });
      }
    },
    getAllWishlistProductAndAddToCart(){
      if(this.lists.length > 0){
        this.lists.forEach((list) => {
          this.addToCart(list);
        });
      }
    },
    async fetchCrossSellProducts() {
      try {
        if(this.lists.length > 0){
          const products = [];
          for (const list of this.lists) {
            if(list.product.sku){
              const crossSellData = await getProductCrossSell(list.product.sku);
              if(crossSellData.items && crossSellData.items.length > 0){
                for (const item of crossSellData.items) {
                  if(item.crosssell_products && item.crosssell_products.length > 0){
                    for (const crosssell_products of item.crosssell_products) {
                      products.push(crosssell_products);
                    }
                  }
                }
              }
            }
          }
          this.rows2 = products.length;
          if(window.innerWidth >= 992) {
            this.crossSellProducts = products;
          }else{
            this.crossSellProducts = products.slice(
              (this.paginationConf2.currentPageNr - 1) * this.paginationConf2.perPage,
              this.paginationConf2.currentPageNr * this.paginationConf2.perPage
            );
          }
        }else{
          this.crossSellProducts = [];
        }
      } catch (err) {
        this.error = "Failed to fetch cross-sell products.";
        console.error(err);
      }
    },
    handleWindowSizeChange() {
      if(window.innerWidth >= 992) {
        this.isMobileScreen = false;
      }else{
        this.isMobileScreen = true;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    const bcrumb = { current: "Wishlist", routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
    if (this.wishlistItems && this.wishlistItems.length > 0) {
      this.fetchCrossSellProducts();
    }
  },
  components: {
    Breadcrumbs,
    ProductCard,
    ClientOnly
  },
  computed: {
    ...mapGetters({
      related: "product/getRelated",
      cartItems: "cart/getCartItems",
    }),
    freeShippingAmount() {
      return this.$store.getters["cart/getFreeShippingAmount"];
    },
    rows() {
      return this.wishlistItems.length;
    },
    lists() {
      if (this.wishlistItems.length === 0) {
        return [];
      }
      const items = this.wishlistItems;
      if(isMobile){
        return items.slice(
          (this.paginationConf.currentPageNr - 1) * this.paginationConf.perPage,
          this.paginationConf.currentPageNr * this.paginationConf.perPage
        );
      }else{
        return items;
      }
    },
  },
  data() {
    return {
      isMobileScreen: false,
      rows2: 0,
      showOrders: true,
      showOrders2: true,
      showNotifyModal: false,
      notifyModalProduct: null,
      paginationConf: {
        currentPageNr: 1,
        totalCount: 0,
        perPage: 2,
      },
      paginationConf2: {
        currentPageNr: 1,
        totalCount: 0,
        perPage: 4,
      },
      noOfItems: 1,
      couponCode: "",
      remarks: {},
      openedRemarks: {},
      shareWishInfo: {
        emails: [],
        emailsState: null,
        emailsError: "",
        message: "",
        messageState: null,
        messageError: "",
      },
      prices: [
        {
          id: "price1",
          name: "Verzendkosten (Verzenden - Via PostNL of DHL)",
          cost: "€ 0,00",
          timeDelivery: "Levertijd: 2 tot 4 werkdagen.",
        },
      ],
      crossSellProducts: [],
    };
  }
};

</script>

<style>
</style>
